/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePolicyResponse } from './CreatePolicyResponse';
import {
    CreatePolicyResponseFromJSON,
    CreatePolicyResponseFromJSONTyped,
    CreatePolicyResponseToJSON,
    CreatePolicyResponseToJSONTyped,
} from './CreatePolicyResponse';

/**
 * 
 * @export
 * @interface ResultOfCreatePolicyResponse
 */
export interface ResultOfCreatePolicyResponse {
    /**
     * 
     * @type {CreatePolicyResponse}
     * @memberof ResultOfCreatePolicyResponse
     */
    data: CreatePolicyResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreatePolicyResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreatePolicyResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreatePolicyResponse interface.
 */
export function instanceOfResultOfCreatePolicyResponse(value: object): value is ResultOfCreatePolicyResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreatePolicyResponseFromJSON(json: any): ResultOfCreatePolicyResponse {
    return ResultOfCreatePolicyResponseFromJSONTyped(json, false);
}

export function ResultOfCreatePolicyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreatePolicyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreatePolicyResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreatePolicyResponseToJSON(json: any): ResultOfCreatePolicyResponse {
    return ResultOfCreatePolicyResponseToJSONTyped(json, false);
}

export function ResultOfCreatePolicyResponseToJSONTyped(value?: ResultOfCreatePolicyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreatePolicyResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

